import {
  GET_LANGUAGE_AND_AUTH_STATE,
  INITIALIZE_LANGUAGE_AND_AUTH_STATE,
  RESET_LANGUAGE_AND_AUTH_STATE,
  UPDATE_LANGUAGE_AND_AUTH_STATE,
} from "../actionTypes/languageAndAuthType";

export const initialWorkFlowState = {
  isApiCallNeedLanguage: true,
  isApiCallNeedAuthentication: true,
  languageData: [],
  authenticationData: [],
};

export const languageAndAuthReducer = (
  state = initialWorkFlowState,
  action = {}
) => {
  switch (action.type) {
    case INITIALIZE_LANGUAGE_AND_AUTH_STATE: {
      return {
        ...state,
      };
    }

    case GET_LANGUAGE_AND_AUTH_STATE: {
      return {
        ...state,
      };
    }

    case UPDATE_LANGUAGE_AND_AUTH_STATE: {
      state = { ...state, ...action.payload };
      console.log(state, "stateeee  cdn");

      return {
        ...state,
        ...action.payload,
      };
    }

    case RESET_LANGUAGE_AND_AUTH_STATE: {
      state = initialWorkFlowState;
      return {
        ...state,
      };
    }
    default:
      return {
        ...state,
      };
  }
};
